var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProgramLibActiveIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 20.5L2 19.1163V5.27907C2.06944 4.68605 2.54167 3.5 3.875 3.5C5.20833 3.5 9.84722 4.94961 12 5.67442V20.5Z",
    stroke: "#01052F",
    strokeWidth: 2.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 20.5L22 19.1163V5.27907C21.9306 4.68605 21.4583 3.5 20.125 3.5C18.7917 3.5 14.1528 4.94961 12 5.67442V20.5Z",
    stroke: "#01052F",
    strokeWidth: 2.5
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgramLibActiveIcon);
export default __webpack_public_path__ + "static/media/ProgramLibActiveIcon.15671b2b9e43499bb290698410206290.svg";
export { ForwardRef as ReactComponent };